import React, { createContext, useContext, useState, useCallback } from 'react';

// Context that provides a simple numeric key to force remounts
const RefreshContext = createContext({
  refreshKey: 0,
  triggerRefresh: () => {}
});

export const RefreshProvider = ({ children }) => {
  const [refreshKey, setRefreshKey] = useState(0);

  const triggerRefresh = useCallback(() => {
    // Increment key – causes consumers to re‑render/remount
    setRefreshKey((k) => k + 1);
  }, []);

  return (
    <RefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
      {children}
    </RefreshContext.Provider>
  );
};

export const useRefresh = () => useContext(RefreshContext);
